import React, {useEffect, useState} from 'react';
import './css/style.min.css'

import pipl from    './img/pipl.svg'
import tis from     './img/tis.svg'
import scryt from   './img/scryt.svg'
import q1 from      './img/q1.svg'
import q2 from      './img/q2.svg'
import as12 from    './img/as12.svg'
import ss1 from     './img/ss1.svg'
import ss2 from     './img/ss2.svg'
import posts1 from  './img/posts1.svg'
import posts2 from  './img/posts2.svg'
import reqwi from   './img/reqwi.png'
import revert from  './img/revert.svg'
import btc from     './img/btc.svg'
import selfi from   './img/selfi.png'
import market from  './img/Market.svg'
import short from   './img/short.svg'
import long from    './img/long.svg'
import im12 from    './img/im12.png'
import {NavLink} from "react-router-dom";
import axios from "axios";
import {createTheme, ThemeProvider} from "@mui/material/styles";
import CircularProgress from "@mui/material/CircularProgress";
import {yellow} from "@mui/material/colors";
import FormData from "form-data";
import {closeSnackbar, enqueueSnackbar} from "notistack";
import CloseIcon from "@mui/icons-material/Close";


const Account = (props) => {
    const [ava, setAva] = useState({});


    (function() {
        function decimalAdjust(type, value, exp) {
            if (typeof exp === 'undefined' || +exp === 0) {
                return Math[type](value);
            }
            value = +value;
            exp = +exp;
            if (isNaN(value) || !(typeof exp === 'number' && exp % 1 === 0)) {
                return NaN;
            }
            value = value.toString().split('e');
            value = Math[type](+(value[0] + 'e' + (value[1] ? (+value[1] - exp) : -exp)));
            value = value.toString().split('e');
            return +(value[0] + 'e' + (value[1] ? (+value[1] + exp) : exp));
        }

        if (!Math.floor10) {
            Math.floor10 = function(value, exp) {
                return decimalAdjust('floor', value, exp);
            };
        }
    })();
    const [coinsPrice, setCoinsPrice] = useState([]);
    const [userData, setUserData] = useState([]);
    const [balance, setBalance] = useState("");
    const [AVG, setAVG] = useState("");

    const token = localStorage.getItem('token');

    const requireUserData = () => axios.get(
        `https://api.fenixodex.net/api/api/users/me`,
        {
            headers: {"Authorization" : `Bearer ${token}`}
        })
        .then(res => {
            setUserData(res.data);
        })
    const requireUserphoto = () => axios.get(
        `https://api.fenixodex.net/api/api/users/avatar`,
        {
            headers: {"Authorization" : `Bearer ${token}`}
        })
        .then(res => {
            let avastyle = {
                backgroundImage: `url(${res.data})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
            }
            setAva(avastyle)
            console.log(res.data)
        })
    const requireBalance = () => axios.get(
        `https://api.fenixodex.net/api/api/users/balance`,
        {
            headers: {"Authorization" : `Bearer ${token}`}
        })
        .then(res => {
            setBalance(res.data);
        })
    axios.get(`https://api.binance.com/api/v3/ticker/24hr?symbols=["BTCUSDT","ETHUSDT","BNBUSDT","XRPUSDT","ADAUSDT","SOLUSDT","APEUSDT","DOTUSDT","LUNAUSDT"]`)
        .then(res => {
            setCoinsPrice(res.data);
            setAVG(coinsPrice[0].lowPrice * balance.btc + coinsPrice[1].lowPrice * balance.eth + coinsPrice[2].lowPrice * balance.bnb + coinsPrice[3].lowPrice * balance.ada + coinsPrice[4].lowPrice * balance.xrp + coinsPrice[6].lowPrice * balance.dot)

        })



    useEffect(() => {
        requireUserData();
        requireBalance();
        requireUserphoto()
    }, []);



    setTimeout(() => {
        let activeElement = document.getElementById(`${props.activeId}`)
        let mainClass = document.getElementById(`main`)
        let meClass = document.getElementById(`me`)
        let depositClass = document.getElementById(`deposit`)
        let withdrawClass = document.getElementById(`withdraw`)
        let walletClass = document.getElementById(`wallet`)
        let kycClass = document.getElementById(`kyc`)
        let ordersClass = document.getElementById(`orders`)
        let portfolioClass = document.getElementById(`portfolio`)

        mainClass.classList.remove("_tab-active")
        meClass.classList.remove("_tab-active")
        depositClass.classList.remove("_tab-active")
        withdrawClass.classList.remove("_tab-active")
        walletClass.classList.remove("_tab-active")
        kycClass.classList.remove("_tab-active")
        ordersClass.classList.remove("_tab-active")
        portfolioClass.classList.remove("_tab-active")

        activeElement.classList.add("_tab-active")

    }, 0)


    const [backDocumentFile, setBackDocumentFile] = useState(null);

    const form = new FormData();

    if (backDocumentFile) {
        form.append('file', backDocumentFile);
    }
    const handleBackDocumentFileChange = (event) => {
        const file = event.target.files[0];
        setBackDocumentFile(file);
    };
    const theme = createTheme({
        palette: {
            primary: {
                main: yellow[600],
            },
        },
    });
    const headers = {
        'accept': 'application/json',
        "Authorization" : `Bearer ${token}`,
        'Content-Type': `multipart/form-data; boundary=${form._boundary}`
    };
    const action = snackbarId => (
        <button onClick={() => { closeSnackbar(snackbarId) }}>
            <CloseIcon/>
        </button>
    );
    const uploadPhoto = () => {
        axios.post('https://api.fenixodex.net/api/api/users/avatar', form, {
                headers: headers
            }
        )
            .then(() => {
setHdnpp(true)
                enqueueSnackbar(`Фото обновлено!`, {action, 'variant': 'success', 'className': "snacksuccess"});
setTimeout(() => {document.location.reload()}, 700)
            })
    }




    const [hdnpp, setHdnpp] = useState(true)
    return (
        <main className="page">

            <div className={`deposit-popup-window ${hdnpp ? "hidden" : ""}`} >
                <div className="dep-popup1234">
                    <div className="rdfngrjdbfjk" onClick={() => setHdnpp(true)}>X</div>
                </div>
                <div className="deposit-popup123" >

                    <div className="centeryo">
                        <p className="kdjsf">Загрузите новое фото</p>
                        <div className="kyc__b-itemdjksfn">
                            <input type="file" name="" id="" onChange={handleBackDocumentFileChange} />
                            <p className="kyc__name">
                                {backDocumentFile ? backDocumentFile.name : "Переместите файл или Найти"}
                            </p>
                            <p className="kyc__sub">
                                Макс. размер изображения - 10 мб
                            </p>
                        </div>
                        <button className="account__s-uploadbtn" onClick={uploadPhoto}>Обновить фото</button>
                    </div>

                </div>

            </div>

            <section className="account h100vh">
                <div className="account__container">
                    <div data-tabs="" className="tabs account__body">
                        <div className="account__sidebar">
                            <div className="account__s-top" >
                                <div className="account__s-item">
                                    <div className="account__s-photo" onClick={() => {setHdnpp(false)}} style={ava}>
                                        <div className="account__s-change">Загрузить фото</div>
                                    </div>
                                </div>
                                <p className="account__name">{userData.displayed_name}</p>
                                <p className="account__date">{userData.email}</p>
                                <nav data-tabs-titles="" className="account__navi tabs__navigation">
                                    <NavLink to="/account/"><button type="submit"          id="main" className="tabs__title ">
                <span>
                  <svg
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M20.5153 9.72843L13.0153 2.65218C13.0116 2.64898 13.0082 2.64554 13.005 2.64187C12.7289 2.39074 12.369 2.25159 11.9958 2.25159C11.6225 2.25159 11.2627 2.39074 10.9866 2.64187L10.9763 2.65218L3.48469 9.72843C3.33187 9.86895 3.20989 10.0397 3.12646 10.2298C3.04303 10.4199 2.99997 10.6252 3 10.8328V19.5C3 19.8978 3.15804 20.2793 3.43934 20.5607C3.72064 20.842 4.10218 21 4.5 21H9C9.39782 21 9.77936 20.842 10.0607 20.5607C10.342 20.2793 10.5 19.8978 10.5 19.5V15H13.5V19.5C13.5 19.8978 13.658 20.2793 13.9393 20.5607C14.2206 20.842 14.6022 21 15 21H19.5C19.8978 21 20.2794 20.842 20.5607 20.5607C20.842 20.2793 21 19.8978 21 19.5V10.8328C21 10.6252 20.957 10.4199 20.8735 10.2298C20.7901 10.0397 20.6681 9.86895 20.5153 9.72843ZM19.5 19.5H15V15C15 14.6022 14.842 14.2206 14.5607 13.9393C14.2794 13.658 13.8978 13.5 13.5 13.5H10.5C10.1022 13.5 9.72064 13.658 9.43934 13.9393C9.15804 14.2206 9 14.6022 9 15V19.5H4.5V10.8328L4.51031 10.8234L12 3.74999L19.4906 10.8216L19.5009 10.8309L19.5 19.5Z" />
                  </svg>{" "}
                </span>
                                        <span>Кабинет</span>
                                    </button></NavLink>
                                    <NavLink to="/account/me"><button type="submit"        id="me" className="tabs__title">
                <span>
                  <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                  >
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M14 7C14 5.897 13.103 5 12 5C10.897 5 10 5.897 10 7C10 8.103 10.897 9 12 9C13.103 9 14 8.103 14 7ZM16 7C16 9.206 14.206 11 12 11C9.794 11 8 9.206 8 7C8 4.794 9.794 3 12 3C14.206 3 16 4.794 16 7ZM5 20C5 16.14 8.141 13 12 13C15.859 13 19 16.14 19 20C19 20.552 18.553 21 18 21C17.447 21 17 20.552 17 20C17 17.243 14.757 15 12 15C9.243 15 7 17.243 7 20C7 20.552 6.553 21 6 21C5.447 21 5 20.552 5 20Z"
                    />
                  </svg>{" "}
                </span>
                                        <span>Личные данные</span>
                                    </button></NavLink>
                                    <NavLink to="/account/deposit"><button type="submit"   id="deposit" className="tabs__title">
                    <span>
                      <svg
                          width={24}
                          height={24}
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M14 7C14 5.897 13.103 5 12 5C10.897 5 10 5.897 10 7C10 8.103 10.897 9 12 9C13.103 9 14 8.103 14 7ZM16 7C16 9.206 14.206 11 12 11C9.794 11 8 9.206 8 7C8 4.794 9.794 3 12 3C14.206 3 16 4.794 16 7ZM5 20C5 16.14 8.141 13 12 13C15.859 13 19 16.14 19 20C19 20.552 18.553 21 18 21C17.447 21 17 20.552 17 20C17 17.243 14.757 15 12 15C9.243 15 7 17.243 7 20C7 20.552 6.553 21 6 21C5.447 21 5 20.552 5 20Z"
                        />
                      </svg>{" "}
                    </span>
                                            <span>Пополнение</span>
                                        </button></NavLink>
                                    <NavLink to="/account/withdraw"><button type="submit"  id="withdraw" className="tabs__title">
                    <span>
                      <svg
                          width={24}
                          height={24}
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                      >
                        <g id="Icon">
                          <path
                              id="Vector"
                              d="M17.0899 9.91667C17.4215 9.91667 17.7394 9.78497 17.9738 9.55055C18.2082 9.31613 18.3399 8.99819 18.3399 8.66667V8.09417C18.3384 6.92039 17.8714 5.79514 17.0414 4.96516C16.2115 4.13517 15.0862 3.66821 13.9124 3.66667H12.9233V3.25C12.9233 2.91848 12.7916 2.60054 12.5572 2.36612C12.3227 2.1317 12.0048 2 11.6733 2C11.3418 2 11.0238 2.1317 10.7894 2.36612C10.555 2.60054 10.4233 2.91848 10.4233 3.25V3.66667H9.43411C8.37117 3.66508 7.34314 4.04595 6.53782 4.7397C5.73249 5.43344 5.20363 6.39375 5.04783 7.44521C4.89203 8.49667 5.1197 9.56908 5.68925 10.4665C6.25881 11.364 7.13222 12.0266 8.14994 12.3333L10.4233 12.955V17.8333H9.43411C8.9231 17.8327 8.43322 17.6294 8.07189 17.2681C7.71056 16.9067 7.50727 16.4168 7.50661 15.9058V15.3333C7.50661 15.0018 7.37491 14.6839 7.14049 14.4494C6.90607 14.215 6.58813 14.0833 6.25661 14.0833C5.92509 14.0833 5.60715 14.215 5.37273 14.4494C5.1383 14.6839 5.00661 15.0018 5.00661 15.3333V15.9058C5.00815 17.0796 5.47512 18.2049 6.3051 19.0348C7.13508 19.8648 8.26033 20.3318 9.43411 20.3333H10.4233V20.75C10.4233 21.0815 10.555 21.3995 10.7894 21.6339C11.0238 21.8683 11.3418 22 11.6733 22C12.0048 22 12.3227 21.8683 12.5572 21.6339C12.7916 21.3995 12.9233 21.0815 12.9233 20.75V20.3333H13.9124C14.9754 20.3349 16.0034 19.954 16.8087 19.2603C17.6141 18.5666 18.1429 17.6062 18.2987 16.5548C18.4545 15.5033 18.2268 14.4309 17.6573 13.5335C17.0877 12.636 16.2143 11.9734 15.1966 11.6667L12.9233 11.0467V6.16667H13.9124C14.4234 6.16733 14.9133 6.37062 15.2747 6.73195C15.636 7.09328 15.8393 7.58317 15.8399 8.09417V8.66667C15.8399 8.99819 15.9716 9.31613 16.2061 9.55055C16.4405 9.78497 16.7584 9.91667 17.0899 9.91667ZM14.4916 14.0658C14.9312 14.2044 15.3067 14.4958 15.5499 14.8873C15.7932 15.2788 15.8882 15.7445 15.8176 16.2001C15.7471 16.6556 15.5158 17.0707 15.1655 17.3704C14.8152 17.67 14.3692 17.8342 13.9083 17.8333H12.9233V13.6375L14.4916 14.0658ZM10.4233 10.3625L8.85494 9.93417C8.41566 9.79573 8.04044 9.50464 7.79716 9.11356C7.55388 8.72248 7.45861 8.25723 7.5286 7.802C7.59858 7.34678 7.82918 6.93163 8.17869 6.63168C8.5282 6.33172 8.97353 6.16677 9.43411 6.16667H10.4233V10.3625Z"
                          />
                        </g>
                      </svg>{" "}
                    </span>
                                            <span>Вывод средств</span>
                                        </button></NavLink>
                                    <NavLink to="/account/wallet"><button type="submit"    id="wallet" className="tabs__title">
                    <span>
                      <svg
                          width={24}
                          height={24}
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                      >
                        <g id="Icon">
                          <path
                              id="icon"
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M15.4506 1.40266C16.5126 1.09921 17.6196 1.7142 17.923 2.77627C17.9741 2.95495 18 3.13988 18 3.32571V4.99998H20C21.1046 4.99998 22 5.89541 22 6.99998V19C22 20.1045 21.1046 21 20 21H4C2.89543 21 2 20.1045 2 19H2.0267C2.00895 18.8924 2 18.7835 2 18.6742V6.75428C2 5.86132 2.59195 5.07655 3.45056 4.83123L15.4506 1.40266ZM10.1401 19H20V11H18V15.2457C18 16.1386 17.408 16.9234 16.5494 17.1687L10.1401 19ZM18 6.99998H20V8.99998H18V6.99998ZM4 6.75426V18.6742L16 15.2457V3.32568L4 6.75426ZM14 8.99998C14 9.55227 13.5523 9.99998 13 9.99998C12.4477 9.99998 12 9.55227 12 8.99998C12 8.4477 12.4477 7.99998 13 7.99998C13.5523 7.99998 14 8.4477 14 8.99998Z"
                          />
                        </g>
                      </svg>{" "}
                    </span>
                                            <span>Кошелек</span>
                                        </button></NavLink>
                                    <NavLink to="/account/kyc"><button type="submit"       id="kyc" className="tabs__title">
                    <span>
                      <svg
                          width={24}
                          height={24}
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                      >
                        <g id="ph:seal-check">
                          <path
                              id="Vector"
                              d="M21.1744 9.63937C20.8209 9.27 20.4553 8.88938 20.3175 8.55469C20.19 8.24813 20.1825 7.74 20.175 7.24781C20.1609 6.33281 20.1459 5.29594 19.425 4.575C18.7041 3.85406 17.6672 3.83906 16.7522 3.825C16.26 3.8175 15.7519 3.81 15.4453 3.6825C15.1116 3.54469 14.73 3.17906 14.3606 2.82562C13.7137 2.20406 12.9788 1.5 12 1.5C11.0212 1.5 10.2872 2.20406 9.63937 2.82562C9.27 3.17906 8.88938 3.54469 8.55469 3.6825C8.25 3.81 7.74 3.8175 7.24781 3.825C6.33281 3.83906 5.29594 3.85406 4.575 4.575C3.85406 5.29594 3.84375 6.33281 3.825 7.24781C3.8175 7.74 3.81 8.24813 3.6825 8.55469C3.54469 8.88844 3.17906 9.27 2.82562 9.63937C2.20406 10.2863 1.5 11.0212 1.5 12C1.5 12.9788 2.20406 13.7128 2.82562 14.3606C3.17906 14.73 3.54469 15.1106 3.6825 15.4453C3.81 15.7519 3.8175 16.26 3.825 16.7522C3.83906 17.6672 3.85406 18.7041 4.575 19.425C5.29594 20.1459 6.33281 20.1609 7.24781 20.175C7.74 20.1825 8.24813 20.19 8.55469 20.3175C8.88844 20.4553 9.27 20.8209 9.63937 21.1744C10.2863 21.7959 11.0212 22.5 12 22.5C12.9788 22.5 13.7128 21.7959 14.3606 21.1744C14.73 20.8209 15.1106 20.4553 15.4453 20.3175C15.7519 20.19 16.26 20.1825 16.7522 20.175C17.6672 20.1609 18.7041 20.1459 19.425 19.425C20.1459 18.7041 20.1609 17.6672 20.175 16.7522C20.1825 16.26 20.19 15.7519 20.3175 15.4453C20.4553 15.1116 20.8209 14.73 21.1744 14.3606C21.7959 13.7137 22.5 12.9788 22.5 12C22.5 11.0212 21.7959 10.2872 21.1744 9.63937ZM20.0916 13.3228C19.6425 13.7916 19.1775 14.2763 18.9309 14.8716C18.6947 15.4434 18.6844 16.0969 18.675 16.7297C18.6656 17.3859 18.6553 18.0731 18.3638 18.3638C18.0722 18.6544 17.3897 18.6656 16.7297 18.675C16.0969 18.6844 15.4434 18.6947 14.8716 18.9309C14.2763 19.1775 13.7916 19.6425 13.3228 20.0916C12.8541 20.5406 12.375 21 12 21C11.625 21 11.1422 20.5387 10.6772 20.0916C10.2122 19.6444 9.72375 19.1775 9.12844 18.9309C8.55656 18.6947 7.90313 18.6844 7.27031 18.675C6.61406 18.6656 5.92688 18.6553 5.63625 18.3638C5.34562 18.0722 5.33437 17.3897 5.325 16.7297C5.31562 16.0969 5.30531 15.4434 5.06906 14.8716C4.8225 14.2763 4.3575 13.7916 3.90844 13.3228C3.45937 12.8541 3 12.375 3 12C3 11.625 3.46125 11.1422 3.90844 10.6772C4.35562 10.2122 4.8225 9.72375 5.06906 9.12844C5.30531 8.55656 5.31562 7.90313 5.325 7.27031C5.33437 6.61406 5.34469 5.92688 5.63625 5.63625C5.92781 5.34562 6.61031 5.33437 7.27031 5.325C7.90313 5.31562 8.55656 5.30531 9.12844 5.06906C9.72375 4.8225 10.2084 4.3575 10.6772 3.90844C11.1459 3.45937 11.625 3 12 3C12.375 3 12.8578 3.46125 13.3228 3.90844C13.7878 4.35562 14.2763 4.8225 14.8716 5.06906C15.4434 5.30531 16.0969 5.31562 16.7297 5.325C17.3859 5.33437 18.0731 5.34469 18.3638 5.63625C18.6544 5.92781 18.6656 6.61031 18.675 7.27031C18.6844 7.90313 18.6947 8.55656 18.9309 9.12844C19.1775 9.72375 19.6425 10.2084 20.0916 10.6772C20.5406 11.1459 21 11.625 21 12C21 12.375 20.5387 12.8578 20.0916 13.3228ZM16.2806 9.21937C16.3504 9.28903 16.4057 9.37175 16.4434 9.46279C16.4812 9.55384 16.5006 9.65144 16.5006 9.75C16.5006 9.84856 16.4812 9.94616 16.4434 10.0372C16.4057 10.1283 16.3504 10.211 16.2806 10.2806L11.0306 15.5306C10.961 15.6004 10.8783 15.6557 10.7872 15.6934C10.6962 15.7312 10.5986 15.7506 10.5 15.7506C10.4014 15.7506 10.3038 15.7312 10.2128 15.6934C10.1217 15.6557 10.039 15.6004 9.96937 15.5306L7.71937 13.2806C7.64969 13.2109 7.59442 13.1282 7.5567 13.0372C7.51899 12.9461 7.49958 12.8485 7.49958 12.75C7.49958 12.6515 7.51899 12.5539 7.5567 12.4628C7.59442 12.3718 7.64969 12.2891 7.71937 12.2194C7.86011 12.0786 8.05098 11.9996 8.25 11.9996C8.34855 11.9996 8.44613 12.019 8.53717 12.0567C8.62822 12.0944 8.71094 12.1497 8.78063 12.2194L10.5 13.9397L15.2194 9.21937C15.289 9.14964 15.3717 9.09432 15.4628 9.05658C15.5538 9.01884 15.6514 8.99941 15.75 8.99941C15.8486 8.99941 15.9462 9.01884 16.0372 9.05658C16.1283 9.09432 16.211 9.14964 16.2806 9.21937Z"
                          />
                        </g>
                      </svg>{" "}
                    </span>
                                            <span>KYC Верификация</span>
                                        </button></NavLink>
                                    <NavLink to="/account/orders"><button type="submit"    id="orders" className="tabs__title">
                <span>
                  <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                  >
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M12 14H9C8.448 14 8 13.552 8 13C8 12.448 8.448 12 9 12H12C12.552 12 13 12.448 13 13C13 13.552 12.552 14 12 14ZM8 17C8 16.448 8.448 16 9 16H15C15.553 16 16 16.448 16 17C16 17.552 15.553 18 15 18H9C8.448 18 8 17.552 8 17ZM17.444 20H6.555C6.249 20 6 19.776 6 19.5V4.5C6 4.224 6.249 4 6.555 4H12V7.15C12 8.722 13.217 10 14.714 10H18V19.5C18 19.776 17.751 20 17.444 20ZM14 4.978L16.742 8H14.714C14.32 8 14 7.619 14 7.15V4.978ZM19.74 8.328L14.296 2.328C14.106 2.119 13.838 2 13.555 2H6.555C5.146 2 4 3.122 4 4.5V19.5C4 20.878 5.146 22 6.555 22H17.444C18.853 22 20 20.878 20 19.5V9C20 8.751 19.907 8.512 19.74 8.328Z"
                    />
                  </svg>
                </span>
                                        <span>История ордеров</span>
                                    </button></NavLink>
                                    {

                                    <NavLink to="/account/portfolio"><button type="submit"    id="portfolio" className="tabs__title">
                <span>
                  <svg className="svg-portfolio" width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M20.2857 11.8333V21H1.71429V11.8333M11 16V12.6667M13.8571 4.33333C13.8571 4.33333 13.8571 1 11 1C8.14286 1 8.14286 4.33333 8.14286 4.33333M1 4.33333H21V11C21 11 16.7143 14.3333 11 14.3333C5.28571 14.3333 1 11 1 11V4.33333Z" stroke="#848e9c" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>


                </span>
                                        <span>Портфель</span>
                                    </button></NavLink>

                                    }
                                    {

                                        <NavLink to="/account/portfolio-stocks"><button type="submit"    id="portfolioStocks" className="tabs__title">
                <span>
                  <svg className="svg-portfolio" width="22" height="22" viewBox="0 0 18 21" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5.00488 3.69336H8.00488V12.6934H5.00488V15.6934H3.00488V12.6934H0.00488281V3.69336H3.00488V0.693359H5.00488V3.69336ZM2.00488 5.69336V10.6934H6.00488V5.69336H2.00488ZM15.0049 8.69336H18.0049V17.6934H15.0049V20.6934H13.0049V17.6934H10.0049V8.69336H13.0049V5.69336H15.0049V8.69336ZM12.0049 10.6934V15.6934H16.0049V10.6934H12.0049Z" stroke="#848e9c"/>
</svg>



                </span>
                                            <span>Портфель Акций</span>
                                            <span className="ptfnew">NEW</span>
                                        </button></NavLink>

                                    }
                                </nav>
                            </div>
                        </div>
                        <div className="account__cont">
                            <div data-tabs-body="" className="tabs__content">
                                {props.children}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </main>

    );
};

export default Account;